import { render, staticRenderFns } from "./PdpTab.vue?vue&type=template&id=3ab3b449&scoped=true"
import script from "./PdpTab.vue?vue&type=script&lang=js"
export * from "./PdpTab.vue?vue&type=script&lang=js"
import style0 from "./PdpTab.vue?vue&type=style&index=0&id=3ab3b449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3b449",
  null
  
)

export default component.exports